import { divider, text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

type TReadonlyFieldProps = {
  label: ReactNode;
  required?: boolean;
  value: ReactNode;
  underline?: boolean;
};

export const ReadonlyField: FC<TReadonlyFieldProps> = ({ label, required, value, underline }) => {
  return (
    <Stack gap="4px" flex={1} minWidth={0}>
      <Typography variant="cap12" color={text.secondary} display="inline-flex" gap={0.5}>
        <span>{label}</span>
        {required && (
          <Typography component="span" color={text.error}>
            {" *"}
          </Typography>
        )}
      </Typography>
      <Typography
        component="div"
        variant="body14Semi"
        color={text.primary}
        sx={underline ? { pb: "8px", borderBottom: `1px solid ${divider.middle}` } : undefined}
      >
        {value ?? "-"}
      </Typography>
    </Stack>
  );
};
